import React from 'react';
import { Link as ReactLink } from 'react-router-dom';

const UrlPattern = /^https?:\/\//;
const LinkResolver = props => (UrlPattern.test(props.to)
  ? <a {...props} href={props.to}>{props.children}</a>
  : <ReactLink {...props} />);

export { LinkResolver as Link };



// WEBPACK FOOTER //
// ./src/view/common/Link/index.jsx